export default "/img/AF.c5dbdc0e871d17646546680e9db42ebe.png";